import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface MijnFNVContentProps {
    title: string;
    content: string;
    cssClass: string;
}

export class MijnFNVContent extends React.Component<MijnFNVContentProps> {
    
    render () {        
        let content = ReactHtmlParser(this.props.content);
        return <>
            <div className={"mijn-fnv-form__content-block " + this.props.cssClass}>
                {this.props.title !== "" && <h2>{this.props.title}</h2> }
                {content}
            </div>
        </>;
    }
}